import React, { useState } from "react";
import { useSelector } from "react-redux";
import axios from "axios";
import MD5 from "crypto-js/md5";
import MDButton from "components/MDButton";
// @mui components
import {
  Grid,
  Divider,
  Button,
  Modal,
  Box,
  TextField,
  Typography,
  IconButton,
  InputAdornment,
  Snackbar,
  Alert,
} from "@mui/material";
import {
  Facebook as FacebookIcon,
  Instagram as InstagramIcon,
  YouTube as YouTubeIcon,
  LinkedIn as LinkedInIcon,
  Visibility,
  VisibilityOff,
} from "@mui/icons-material";

// Material Dashboard components
import MDBox from "components/MDBox";
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import Footer from "examples/Footer";
import ProfileInfoCard from "examples/Cards/InfoCards/ProfileInfoCard";
import Header from "layouts/profile/components/Header";
import PaymentWalletCard from "./components/PaymentWallet";

function Overview() {
  const account = useSelector((state) => state.account.data?.accountModel?.account);
  const fullName = account ? `${account.firstName || ""} ${account.lastName || ""}`.trim() : "";
  const Mobile = account?.phoneNumber;
  const emailId = account?.emailId;
  const address = account?.address;
  const orgHandle = account?.orgHandle;

  console.log("Account Data:", account);

  // Modal + Snackbar state
  const [open, setOpen] = useState(false);
  const [snackbar, setSnackbar] = useState({ open: false, message: "", severity: "success" });

  // Form fields
  const [oldPassword, setOldPassword] = useState("");
  const [newPassword, setNewPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [loading, setLoading] = useState(false);

  // Show/hide toggles
  const [showOld, setShowOld] = useState(false);
  const [showNew, setShowNew] = useState(false);
  const [showConfirm, setShowConfirm] = useState(false);

  const [activeUsers, setActiveUsers] = useState([]);
  const [activeData, setActiveData] = useState(null);

  // ✅ Snackbar handler
  const showSnackbar = (message, severity = "success") => {
    setSnackbar({ open: true, message, severity });
  };

  const handleSubmit = async () => {
    if (!oldPassword || !newPassword || !confirmPassword) {
      showSnackbar("Please fill all fields", "warning");
      return;
    }
    if (newPassword !== confirmPassword) {
      showSnackbar("New Password and Confirm Password do not match", "error");
      return;
    }

    try {
      setLoading(true);
      const token = localStorage.getItem("token");
      await axios.post(
        "https://v3.dhundhoo.com/auth/changePassword",
        {
          map: {
            oldPassword: MD5(oldPassword).toString(),
            newPassword: MD5(newPassword).toString(),
          },
        },
        {
          headers: {
            "Content-Type": "application/json",
            "x-dhundhoo-session": token,
          },
        }
      );

      showSnackbar("Password changed successfully!", "success");
      setOpen(false);
      setOldPassword("");
      setNewPassword("");
      setConfirmPassword("");
    } catch (error) {
      showSnackbar(error.response?.data?.message || "Failed to change password", "error");
    } finally {
      setLoading(false);
    }
  };

  const getActiveUsers = async () => {
    try {
      const token = localStorage.getItem("token");
      const res = await axios.get("https://v3.dhundhoo.com/activeUsers", {
        headers: { "x-dhundhoo-session": token },
      });

      setActiveData(res.data || null);
    } catch (error) {
      console.error("Failed to fetch active users", error);
    }
  };

const getActiveUsersDownload = async () => {
  try {
    const res = await axios.get(
      `https://v3.dhundhoo.com/api/org/${orgHandle}/active-users`,
    
    );

    const data = res.data;

    const csvRows = [];

    // Header
    csvRows.push("totalRegisteredUsers,totalActiveUsers,ActivePhoneNumbers");

    // First row (with first phone number)
    csvRows.push(
      `${data.totalRegisteredUsers},${data.totalActiveUsers},${data.activePhoneNumbers[0] || ""}`
    );

    // Remaining phone numbers
    for (let i = 1; i < data.activePhoneNumbers.length; i++) {
      csvRows.push(`,,${data.activePhoneNumbers[i]}`);
    }

    const csvContent = csvRows.join("\n");

    // Download
    const blob = new Blob([csvContent], { type: "text/csv" });
    const url = window.URL.createObjectURL(blob);

    const a = document.createElement("a");
    a.href = url;
    a.download = "active_users.csv";
    a.click();

    window.URL.revokeObjectURL(url);

    showSnackbar("CSV downloaded successfully", "success");

  } catch (error) {
    console.error("Failed to fetch active users", error);
    showSnackbar("Failed to download CSV", "error");
  }
};

  React.useEffect(() => {
    getActiveUsers();
  }, []);

  return (
    <DashboardLayout>
      <DashboardNavbar />
      <MDBox mb={2} />

      <Header>
        <MDBox mt={2} mb={3} display="flex" justifyContent="flex-end" alignItems="center" pr={3} gap={2}>

          <MDButton
            variant="contained"
            color="warning"
            onClick={getActiveUsersDownload}
            sx={{ borderRadius: "10px", textTransform: "none" }}
          >
            Active Users
          </MDButton>

          <MDButton
            variant="contained"
            color="warning"
            onClick={() => setOpen(true)}
            sx={{ borderRadius: "10px", textTransform: "none", color: "#fff" }}
          >
            Change Password
          </MDButton>

        </MDBox>

        <MDBox mt={3} mb={3}>
          <Grid container spacing={2}>
            {/* Profile Info */}
            <Grid item xs={12} md={6} xl={6} sx={{ display: "flex" }}>
              <Divider orientation="vertical" sx={{ ml: -2, mr: 1 }} />
              <ProfileInfoCard
                title="Profile Information"
                info={{
                  fullName,
                  mobile: Mobile,
                  email: emailId,
                  location: address,
                }}
                social={[
                  { link: "https://www.facebook.com/dhundhoo", icon: <FacebookIcon />, color: "facebook" },
                  { link: "https://www.instagram.com/dhundhoo/", icon: <InstagramIcon />, color: "instagram" },
                  { link: "https://www.youtube.com/channel/UClfCzK8n05t89KrC0TPIwMA", icon: <YouTubeIcon />, color: "youtube" },
                  { link: "https://www.linkedin.com/company/13210931/admin/dashboard/", icon: <LinkedInIcon />, color: "linkedin" },
                ]}
                action={{ route: "" }}
                shadow={false}
              />
              <Divider orientation="vertical" sx={{ mx: 0 }} />
            </Grid>

            {/* Wallet */}
            <Grid item xs={12} md={6} xl={4}>
              {localStorage.getItem("isWallet") === "true" && <PaymentWalletCard />}

              {activeData && (
                <Box
                  mt={2}
                  p={3}
                  sx={{
                    borderRadius: "15px",
                    border: "1px solid #e0e0e0",
                    boxShadow: "0 4px 12px rgba(0,0,0,0.06)",
                    background: "#fff",
                  }}
                >
                  <Typography
                    variant="h6"
                    sx={{ fontWeight: 600, color: "#1a1a1a", mb: 2 }}
                  >
                    Active User Statistics
                  </Typography>

                  <Box sx={{ lineHeight: 1.9 }}>
                    <Typography sx={{ fontSize: "15px", color: "#333" }}>
                      <strong>Total Users:</strong> {activeData.totalUsers}
                    </Typography>

                    <Typography sx={{ fontSize: "15px", color: "#333" }}>
                      <strong>Active Users:</strong>{" "}
                      <span style={{ color: "#1A73E8", fontWeight: 600 }}>
                        {activeData.activeUsers}
                      </span>
                    </Typography>

                    <Typography sx={{ fontSize: "15px", color: "#333" }}>
                      <strong>Inactive Users:</strong>{" "}
                      <span style={{ color: "red", fontWeight: 600 }}>
                        {activeData.inactiveUsers}
                      </span>
                    </Typography>
                  </Box>

                  <Divider sx={{ my: 2 }} />

                  <Typography
                    sx={{
                      fontSize: "15px",
                      fontWeight: 600,
                      color: "#1a1a1a",
                      mb: 1,
                    }}
                  >
                    Platform Usage:
                  </Typography>

                  <Box sx={{ lineHeight: 1.9 }}>
                    <Typography sx={{ fontSize: "15px", color: "#333" }}>
                      Android:{" "}
                      <strong style={{ color: "#1A73E8" }}>
                        {activeData.platformCount?.ANDROID}
                      </strong>
                    </Typography>

                    <Typography sx={{ fontSize: "15px", color: "#333" }}>
                      iOS:{" "}
                      <strong style={{ color: "#1A73E8" }}>
                        {activeData.platformCount?.IOS}
                      </strong>
                    </Typography>
                  </Box>
                </Box>
              )}

            </Grid>

          </Grid>
        </MDBox>
      </Header>

      <Footer />

      {/* ✅ Change Password Modal */}
      <Modal open={open} onClose={() => setOpen(false)}>
        <Box
          sx={{
            position: "absolute",
            top: "50%",
            left: "50%",
            transform: "translate(-50%, -50%)",
            width: 400,
            bgcolor: "background.paper",
            boxShadow: 24,
            borderRadius: 2,
            p: 4,
          }}
        >
          <Typography variant="h6" mb={2}>
            Change Password
          </Typography>

          <TextField
            fullWidth
            label="Old Password"
            type={showOld ? "text" : "password"}
            value={oldPassword}
            onChange={(e) => setOldPassword(e.target.value)}
            sx={{ mb: 2 }}
            InputProps={{
              endAdornment: (
                <InputAdornment position="end">
                  <IconButton onClick={() => setShowOld(!showOld)}>
                    {showOld ? <VisibilityOff /> : <Visibility />}
                  </IconButton>
                </InputAdornment>
              ),
            }}
          />

          <TextField
            fullWidth
            label="New Password"
            type={showNew ? "text" : "password"}
            value={newPassword}
            onChange={(e) => setNewPassword(e.target.value)}
            sx={{ mb: 2 }}
            InputProps={{
              endAdornment: (
                <InputAdornment position="end">
                  <IconButton onClick={() => setShowNew(!showNew)}>
                    {showNew ? <VisibilityOff /> : <Visibility />}
                  </IconButton>
                </InputAdornment>
              ),
            }}
          />

          <TextField
            fullWidth
            label="Confirm Password"
            type={showConfirm ? "text" : "password"}
            value={confirmPassword}
            onChange={(e) => setConfirmPassword(e.target.value)}
            error={confirmPassword !== "" && confirmPassword !== newPassword}
            helperText={
              confirmPassword !== "" && confirmPassword !== newPassword
                ? "Passwords do not match"
                : ""
            }
            sx={{ mb: 3 }}
            InputProps={{
              endAdornment: (
                <InputAdornment position="end">
                  <IconButton onClick={() => setShowConfirm(!showConfirm)}>
                    {showConfirm ? <VisibilityOff /> : <Visibility />}
                  </IconButton>
                </InputAdornment>
              ),
            }}
          />

          <Box display="flex" justifyContent="flex-end" gap={1}>
            <Button onClick={() => setOpen(false)} color="secondary" disabled={loading}>
              Cancel
            </Button>
            <Button
              variant="contained"
              color="primary"
              onClick={handleSubmit}
              disabled={loading || confirmPassword !== newPassword}
              sx={{ color: "#fff" }}
            >
              {loading ? "Updating..." : "Submit"}
            </Button>
          </Box>
        </Box>
      </Modal>

      {/* ✅ Snackbar */}
      <Snackbar
        open={snackbar.open}
        autoHideDuration={3000}
        onClose={() => setSnackbar({ ...snackbar, open: false })}
        anchorOrigin={{ vertical: "bottom", horizontal: "center" }}
      >
        <Alert
          severity={snackbar.severity}
          onClose={() => setSnackbar({ ...snackbar, open: false })}
          sx={{ width: "100%" }}
        >
          {snackbar.message}
        </Alert>
      </Snackbar>
    </DashboardLayout>
  );
}

export default Overview;
